export default "__VITE_ASSET__1eb5a579__"